<script>
import { autorotate, Viewer } from 'marzipano';
import { mapGetters } from 'vuex';

export default {
  name: 'MarzipanoViewer',
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
    autorotateSettings: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      viewer: undefined,
    }
  },
  computed: {
    ...mapGetters('nativePanorama', ['scene']),
  },
  watch: {
    scene(index) {
      const scene = this.viewer.listScenes()[index];

      if (scene) {
        scene.switchTo();
      }
    },
  },
  mounted() {
    this.$el.appendChild(this.viewer.domElement());
    this.viewer.updateSize();

    const scene = this.viewer.listScenes()[this.scene];

    if (scene) {
      scene.switchTo();
    }

    this.initAutorotate();
  },
  beforeDestroy() {
    if (this.viewer) {
      this.viewer.destroy();
    }
  },
  render(h) {
    if (!this.viewer) {
      this.viewer = this.createViewer();
    }

    return h('div', { class: 'marzipano-container' }, this.$slots.default);
  },
  methods: {
    createViewer() {
      return new Viewer(document.createElement('div'), this.options);
    },
    initAutorotate() {
      if (this.autorotateSettings) {
        const settings = autorotate(this.autorotateSettings);

        if (this.autorotateSettings.idleTimeToMovement) {
          this.viewer.setIdleMovement(this.autorotateSettings.idleTimeToMovement, settings);
        } else {
          this.viewer.startMovement(settings);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.marzipano-container {
  width: 100%;
  height: 100%;
  background: #999;
  display: grid;
}
</style>
